
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-started",
      function () {
        return require("private-next-pages/get-started/index.tsx");
      }
    ]);
  